import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "icon", "onClick"];
import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { MenuContext } from '../Menu/Menu.context';
import { StyledMenuItem } from './MenuItem.styles';

/**
 * Menu items are HTML buttons by default that close the `Menu` and take an action when
 * clicked.
 *
 * @since 7.28.0
 */
export var MenuItem = function MenuItem(props) {
  var _useContext = useContext(MenuContext),
    onActivate = _useContext.onActivate;
  var children = props.children,
    icon = props.icon,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded);
  var onClickCallback = useCallback(function (e) {
    // Let `Menu` know the item was activated
    if (onActivate) {
      onActivate();
    }

    // Take the action
    if (onClick) {
      onClick(e);
    }
  }, [onActivate, onClick]);
  return /*#__PURE__*/React.createElement(StyledMenuItem, _extends({}, rest, {
    onClick: onClickCallback
  }), icon, children);
};
MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Item text content.
   */
  'children': PropTypes.node.isRequired,
  /**
   * An optional `Icon` node.
   */
  'icon': PropTypes.node,
  /**
   * The action to perform when the menu item is activated with a click or with keyboard
   * interaction.
   */
  'onClick': PropTypes.func,
  /**
   * Menu items have the role of `"menuitem"` by default per the
   * [accesibility guidelines](https://www.w3.org/WAI/ARIA/apg/example-index).
   */
  'role': PropTypes.string,
  /**
   * Set the menu item as disabled when using a button.
   */
  'disabled': PropTypes.bool,
  /**
   * Use aria-disabled in the event that the menu item is an `Anchor`.
   */
  'aria-disabled': PropTypes.bool
} : {};
MenuItem.defaultProps = {
  'icon': undefined,
  'onClick': undefined,
  'role': 'menuitem',
  'disabled': undefined,
  'aria-disabled': undefined
};